<template>
  <div class="tabulka full">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">
        <template v-if="archived"> Archived Campaigns </template>
        <template v-else> New Campaigns </template>
      </div>
      <div class="tabulka__top__countCampaign" v-if="adLimitActive()">
        {{ getCurrentAds() }}/{{ getMaximumAds() }} ads
      </div>
    </div>
    <ProductCampaignRow
      v-for="(campaign, i) in source"
      :key="`Campaign-${i}-${campaign.product.id}`"
      :campaign="campaign"
      :archive="archived"
    />

    <div
      v-if="!archived && productsWithoutCampaign.length"
      class="tabulka__middleButton"
      @click="newCampaign(null)"
    >
      Add campaign
    </div>

    <p
      v-if="!archived && !teamProducts.length"
      v-text="$t(`texts.data.no-products-created`)"
    />
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import ProductCampaignRow from "@/components/game/table/ProductCampaignRow.vue";

export default {
  name: "CampaignsTable",
  components: {
    ProductCampaignRow,
  },
  props: {
    archived: Boolean,
  },
  computed: {
    ...mapGetters({
      teamProducts: "teamProducts",
      productsWithoutCampaign: "productsWithoutCampaign",
      groupedCampaigns: "groupedCampaigns",
      groupedArchivedCampaigns: "groupedArchivedCampaigns",
      team: "gameTeam",
      game: "activeGame",
    }),
    source() {
      return this.archived
        ? this.groupedArchivedCampaigns
        : this.groupedCampaigns;
    },
  },
  methods: {
    async newCampaign(productId = null) {
      await this.$store.dispatch("addTempCampaign", productId);
    },
    getCurrentAds() {
      if (this.team != null) {
        var pocet = this.team.adCountCurrentTurn;
        return pocet;
      }
      return 0;
    },
    getMaximumAds() {
      if (this.game != null) {
        if (this.game.adLimitPerTurn != null) {
          return this.game.adLimitPerTurn;
        } else {
          return 0;
        }
      }
    },
    adLimitActive() {
      if (this.game != null) {
        if (this.game.adLimitPerTurn != null && this.game.adLimitPerTurn > 0) {
          return true;
        } else {
          return false;
        }
      }
    },
    refreshComponent() {
      this.$forceUpdate();
    },
  },
};
</script>
